/**
 * useOfferDetail
 * Fetches offer detail with payment options and user info from /backoffice/offers/{offerId}
 */
import { useQuery } from '@tanstack/react-query';
import { getOfferDetail } from '@/services/credit-engine.service';

export function useOfferDetail(offerId: string, directoryId: string) {
  const query = useQuery({
    queryKey: ['backoffice', 'offers', offerId, directoryId],
    queryFn: () => getOfferDetail(offerId, directoryId),
    enabled: Boolean(offerId && directoryId),
  });

  return {
    offer: query.data?.data?.offer ?? null,
    user: query.data?.data?.user ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
